<div class="line">
  <mat-icon *ngIf="isEditable"
    (click)="openDialog()"
    class="material-icons-outlined"
    [class.obs]="value.observacao || value.ambiente"
  >
    {{ getTypeIcon() ? 'description' : 'note_add' }}
  </mat-icon>

  <mat-icon *ngIf="!isEditable"
    (click)="openDialog()"
    class="material-icons-outlined"
    [class.obs]="value.observacao! || value.ambiente"
  >
    info
  </mat-icon>
</div>
